import { createActionConst } from '../../../utils/action.utils';

const AGENCY_TOOLS_PAGE_NAMESPACE = 'AGENCY_TOOLS_PAGE';

export const AGENCY_TOOLS_PAGE = createActionConst(AGENCY_TOOLS_PAGE_NAMESPACE, 'AGENCY_TOOLS_PAGE');
